<template>
    <div>
        <v-page-header
            :back="{
                title: '组织架构',
                goBack: goback,
            }"
            title="从企业微信导入员工"
        />
        <result
            :icon="iconName"
            :icon-style="style"
            :title="title"
            :title-style="titleStyle"
            :sub-title="subTitle"
            :describe="describe"
        >
            <div v-if="buttonText" slot="buttonText" class="button-text">
                <v-button v-if="onStatus == 'imports'" status="primary" size="large" @click="refreshResult(onStatus)">
                    刷新查看结果
                </v-button>
                <v-button
                    :status="onStatus == 'error' ? 'primary' : 'default'"
                    size="large"
                    @click="onCancel(onStatus)"
                >
                    {{ buttonText }}
                </v-button>
            </div>
            <template v-if="onStatus == 'imports'" slot="describe">
                <p class="v-result-describe">
                    返回后，从企业微信导入员工仍在后台进行，导入完成后可在【组织架构】页面查看导入结果<br />
                    但直到导入完成前，都不能修改组织架构
                </p>
            </template>
        </result>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import Gateway from '@/utils/Gateway';
import Result from '@/components/result';
import { getContactConfigPage } from '@/cgi/getConfig';

const req = require.context('../assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);
export default {
    components: {
        Result
    },

    props: {
        isOrgInited: {
            type: Boolean,
            default: false
        },

        isImportIng: {
            type: Boolean,
            default: false
        },

        syncStatus: {
            type: Number,
            default: 0
        },

        hasError: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            installVisible: false,
            isBind: true,
            loading: false,

            // 图标
            iconName: '',
            style: {},

            // 标题样式
            titleStyle: {},

            // 内容
            title: '',
            subTitle: '',
            buttonText: '',
            describe: '',

            // 当前状态
            onStatus: '',

            // 成功字体颜色
            onColor: '#00D48A',

            importTaskId: -1,
            contactConfigPage: ''
        };
    },
    created() {
        this.showByStatus();

        getContactConfigPage().then(url => {
            this.contactConfigPage = url;
        });
    },
    methods: {
        jumpRoute(path) {
            this.$router.push(path);
        },
        goback() {
            window.location.href = '/mng/org';
        },

        // 根路径跳转
        replaceRoute(path) {
            window.location.replace(path);
        },

        // 当前状态, 图标name，图标样式，标题，标题样式，按钮，描述，原因，成功字体颜色
        onChange(onStatus, iconName, style, title, titleStyle, buttonText, describe, subTitle, onColor) {
            this.onStatus = onStatus;
            this.iconName = iconName;
            this.style = style;
            this.title = title;
            this.titleStyle = titleStyle;
            this.buttonText = buttonText;
            this.describe = describe;
            this.subTitle = subTitle;
            this.onColor = onColor;
        },

        showByStatus() {
            if (this.hasError) {
                this.onChange(
                    'error',
                    'err',
                    {
                        width: 105,
                        height: 108,
                        'margin-top': '45px'
                    },
                    '通讯录同步异常，无法从企业微信导入员工，请尽快修复',
                    {
                        'font-size': '20px',
                        'line-height': '28px'
                    },
                    '去修复'
                );
            } else if (this.isOrgInited) {
                if (this.isImportIng) {
                    // 导入企微员工_导入中
                    this.onChange(
                        'imports',
                        'wait-imports',
                        {
                            width: 320,
                            height: 200,
                            'margin-top': '-25px'
                        },
                        '企业微信员工导入中...',
                        {},
                        '返回组织架构',
                        ''
                    );
                }
            } else {
                this.onChange(
                    'notready',
                    'no-ready',
                    {
                        width: 95,
                        height: 90,
                        'margin-top': '50px'
                    },
                    '企业微信组织架构准备中，请明天再来',
                    {
                        'font-size': '20px',
                        'line-height': '28px'
                    },
                    '知道了'
                );
            }
        },

        onCancel() {
            if (this.onStatus === 'error') {
                window.location.href = this.contactConfigPage;
            } else if (this.onStatus === 'notready' || this.onStatus === 'imports') {
                window.location.href = '/mng/org';
            }
        },

        refreshResult() {
            if (this.importTaskId < 0) {
                this.getImportTaskId().then(() => {
                    this.getImportResult();
                });
            } else if (this.importTaskId > 0) {
                this.getImportResult();
            } else {
                this.$router.push('/mng/org/importStaff/result');
            }
        },

        getImportResult() {
            Gateway.get('/v1/wework/ManualImportResult').then(data => {
                const { id } = data || {};

                if (this.importTaskId === 0 || id === this.importTaskId) {
                    this.$router.push('/mng/org/importStaff/result');
                }
            });
        },

        getImportTaskId() {
            return Gateway.get('/v1/wework/SyncStatus').then(data => {
                if (data) {
                    this.importTaskId = data.task_id;
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
@import '../style.less';
.export {
    margin-right: 20px;
}
</style>
